import { FC } from "react";
import { Box, CircularProgress, Typography } from "@material-ui/core";
import { some } from "lodash";

import { RoyaltyPayorImage } from "components";
import CanGetValuationIcon from "components/RoyaltyPayorImage/CanGetValuationIcon";
import { EMPTY_VALUE_PLACEHOLDER } from "constants/index";
import { useRoyaltyPayors } from "services/royaltyPayor";

interface TimeForEstimationProps {
  royaltyPayorName: string;
  hasGetCredentialPermission?: boolean;
}

const TimeForEstimation: FC<TimeForEstimationProps> = ({
  royaltyPayorName,
}) => {
  const { data: royaltyPayors, isLoading } = useRoyaltyPayors();

  const royaltyPayor = royaltyPayors?.find(
    rp => rp.display_name === royaltyPayorName,
  );
  const canGetValuation = some(royaltyPayor?.permissions, {
    codename: "get_valuation",
  });

  return isLoading ? (
    <CircularProgress />
  ) : (
    <Box display="flex" alignItems="center">
      <Box maxWidth="40%">
        <RoyaltyPayorImage
          height="unset"
          royaltyPayor={royaltyPayor}
          displayCanGetValuationIcon={false}
        />
      </Box>
      <Box textAlign="left" ml={1}>
        <Typography variant="h6">
          {royaltyPayor?.display_name ?? EMPTY_VALUE_PLACEHOLDER}
        </Typography>
        <Typography>
          <CanGetValuationIcon canGetValuation={canGetValuation} showLabel />
        </Typography>
      </Box>
    </Box>
  );
};

export default TimeForEstimation;
